import React, {PureComponent} from "react"
import {BirthdayBoxMetadata, Deal, BasketItemType} from "@irati/types"
import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import {H2} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import {Para} from "@irati/ui/src/Labels"
import Form from "@irati/ui/src/Form"
import {Select} from "@irati/ui/src/FormItem"
import basket from "@irati/checkout/utils/basket"

interface Props extends InjectIntl {
  deal: Deal,
  products: BirthdayBoxMetadata[]
}

interface State {
  selectedProductId: string | null
}

class BirthdayBoxProduct extends PureComponent<Props, State> {
  state = {
    selectedProductId: null
  }

  selectProduct = (productUuid: string) => {
    const selectedProduct = this.props.products.find((t) => t.productId === productUuid)
    basket.clear()
    if (selectedProduct) {
      this.setState({selectedProductId: selectedProduct.productId})
      const {productId, linkProduct} = selectedProduct
      basket.setProduct(BasketItemType.Deal, this.props.deal.uuid, productId, {count: 1})
      basket.setProduct(BasketItemType.Deal, this.props.deal.uuid, linkProduct, {count: 1})
    } else {
      this.setState({selectedProductId: null})
    }
  }

  render() {
    return (
      <Flex direction="column">
        <H2>
          <FormattedMessage id="perks.components.productForms.birthdayBoxSelection.title" />
        </H2>
        <Para marginBottom={2}>
          <FormattedMessage id="perks.components.productForms.birthdayBoxSelection.text" />
        </Para>
        <Form>
          <Select
            label={this.props.formatMessage({id: "perks.components.productForms.birthdayBoxSelection.label"})}
            placeholder={this.props.formatMessage({id: "perks.components.productForms.birthdayBoxSelection.placeholder"})}
            value={this.state.selectedProductId}
            options={this.props.products}
            onChange={this.selectProduct} />
        </Form>
      </Flex>
    )
  }
}

export default injectIntl(BirthdayBoxProduct)
